import { ApiService } from '@services/api';
import { API_DOMAIN } from '@constants/api';
import {
  IGetCredentialProps,
  ICreateCredentialProps,
  IUpdateCredentialProps,
} from '@domain/interfaces/dashboard/IntegrationCenter/InfoProduct/Platforms/IHotmartAuth';

export class HotmartService {
  private readonly apiService: ApiService;

  constructor(baseURL: string) {
    this.apiService = new ApiService(baseURL);
  }

  public getCredential({ storeAliasId }: IGetCredentialProps): Promise<any> {
    return this.apiService.get(`/api/v1/users/stores/${storeAliasId}/hotmart-credentials`);
  }

  public createCredential({ storeAliasId, data }: ICreateCredentialProps): Promise<any> {
    return this.apiService.post(`/api/v1/users/stores/${storeAliasId}/hotmart-credentials`, {
      ...data,
    });
  }

  public updateCredential({
    storeAliasId,
    credentialAliasId,
    data,
  }: IUpdateCredentialProps): Promise<any> {
    return this.apiService.put(
      `/api/v1/users/stores/${storeAliasId}/hotmart-credentials/${credentialAliasId}`,
      {
        ...data,
      },
    );
  }
}

const hotmartService = new HotmartService(API_DOMAIN);

export default hotmartService;
